import {
  useCanOpenDocuments,
  usePermissionState,
  type PermissionState,
} from '@/hooks/usePermission';

// Acceso a la Lista Maestra (G4, cierre F1, nota de QA FUN-06): por el permiso de lectura
// del rol o por un acceso temporal de proveedor vigente (el backend limita qué ve).
// Mientras /me carga es `loading`; si falla, `error` con reintento.

export function useMasterListAccess(): {
  state: PermissionState;
  retry: () => void;
  retrying: boolean;
  error: unknown;
} {
  const perm = usePermissionState('quality:master-list:read');
  const byGrant = useCanOpenDocuments();
  return { ...perm, state: perm.state === 'denied' && byGrant ? 'granted' : perm.state };
}
